import './App.css';
import Intro from './components/Intro.js'
import Info from './components/Info.js'
import Projects from './components/Projects.js'
import Loader from './components/Loader.js'
import Footer from './components/Footer.js'
import React, { useState, useEffect } from "react"
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckSquare, faCoffee, faArrowRight, faArrowLeft, faInfo, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons'

library.add(faCheckSquare, faCoffee, faArrowRight, faArrowLeft, faInfo, faArrowUp, faArrowDown)

function App() {
  const [bgcolor, setBgcolor] = useState(null)
  const [loading, setLoading] = useState(true)
  const [lang, setLang] = useState('ESP')

  function changeBackground(color) {
    setBgcolor(color)
  }

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000)
  }, [])

  if (loading === true) return <Loader />

  return (
    <div className="App" style={{ backgroundColor: bgcolor, transition: 'background-color 0.6s ease' }}>
      <Info lang={lang} />
      <Intro lang={lang} setLang={setLang} />
      <Projects passedDownone={changeBackground} poop={bgcolor} lang={lang} />
      <Footer />
    </div>
  )
}

export default App
